var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-group" },
    [
      !_vm.blockoutDay.inEditMode &&
      !_vm.blockoutDay.inAddMode &&
      !_vm.isEndDateAlreadyPassed(_vm.blockoutDay)
        ? _c(
            "md-button",
            {
              staticClass: "md-warning md-just-icon md-round",
              class: _vm.disableActionButtons ? "md-disabled" : "",
              attrs: {
                disabled: _vm.disableActionButtons,
                title: "Edit blockout day",
              },
              on: {
                click: function ($event) {
                  return _vm.editBlockoutDay(_vm.blockoutDay)
                },
              },
            },
            [_c("md-icon", [_vm._v("edit")])],
            1
          )
        : _vm._e(),
      _vm.blockoutDay.inEditMode || _vm.blockoutDay.inAddMode
        ? _c(
            "md-button",
            {
              staticClass: "md-success md-just-icon md-round",
              attrs: { title: "Save" },
              on: {
                click: function ($event) {
                  return _vm.handleSaveChanges(_vm.blockoutDay)
                },
              },
            },
            [_c("md-icon", [_vm._v("check")])],
            1
          )
        : _vm._e(),
      _c("blockout-days-add-attachment-button", {
        attrs: {
          "blockout-day": _vm.blockoutDay,
          "disable-action-buttons": _vm.disableActionButtons,
        },
        on: {
          saveBlockoutDay: _vm.handleSaveBlockoutDay,
          imageListUpdate: _vm.handleImageListUpdate,
          documentListUpdate: _vm.handleDocumentListUpdate,
        },
      }),
      _c("blockout-days-delete-button", {
        attrs: {
          "blockout-day": _vm.blockoutDay,
          "disable-action-buttons": _vm.disableActionButtons,
          "is-end-date-already-passed": _vm.isEndDateAlreadyPassed,
        },
        on: { delete: _vm.handleDeleteBlockoutDay },
      }),
      _vm.blockoutDay.inAddMode
        ? _c(
            "md-button",
            {
              staticClass: "md-danger md-just-icon md-round",
              attrs: { title: "Remove" },
              on: {
                click: function ($event) {
                  return _vm.removeBlockoutDay()
                },
              },
            },
            [_c("md-icon", [_vm._v("remove")])],
            1
          )
        : _vm._e(),
      _vm.blockoutDay.inEditMode
        ? _c(
            "md-button",
            {
              staticClass: "md-info md-just-icon md-round",
              attrs: { title: "Undo changes" },
              on: {
                click: function ($event) {
                  return _vm.undoChangesOnBlockoutDay(_vm.blockoutDay)
                },
              },
            },
            [_c("md-icon", [_vm._v("restart_alt")])],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }